import { RemoveHouseholdMember } from '../../../src/components'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <RemoveHouseholdMember />
    </div>
  )
}
